import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from 'components/UnvUI'

import Notification from 'utils/Notifications'
import {
  getAccreditation,
  downloadAccreditation,
} from 'service/ReportsService'

import AccreditationGrid from './components/AccreditationGrid/AccreditationGrid'
import YearFilter from './components/YearFilter/YearFilter'
import styles from './AccreditationReportPage.module.scss'

const AccreditationReportPage = () => {
  const { t } = useTranslation('common')
  const currentYear = new Date().getFullYear()
  const [year, setYear] = useState(currentYear)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const load = async () => {
    setLoading(true)
    setError(false)
    try {
      const res = await getAccreditation(year)
      setData(res.data || null)
    } catch {
      setError(true)
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [year])

  const handleDownload = async (fmt) => {
    try {
      await downloadAccreditation(year, fmt)
      setNotify({ isOpen: true, message: t('reports.file_downloaded'), type: 'success', sound: 'success' })
    } catch {
      setNotify({ isOpen: true, message: t('reports.file_download_failed'), type: 'error', sound: 'error' })
    }
  }

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('reports.accreditation_title')}</h1>
        <div className={styles.subtitle}>{t('reports.accreditation_subtitle')}</div>
      </div>

      <div className={`unv-card ${styles.toolbar}`}>
        <YearFilter value={year} onChange={setYear} />
        <button className={`unv-btn ${styles.btn} ${styles.btnPrimary}`} onClick={load}>
          {t('reports.load_btn')}
        </button>
        <div className={styles.toolbarSpacer} />
        <button className={`unv-btn ${styles.btn}`} onClick={() => handleDownload('xlsx')}>
          XLSX
        </button>
        <button className={`unv-btn ${styles.btn}`} onClick={() => handleDownload('csv')}>
          CSV
        </button>
      </div>

      <div className={styles.content}>
        {loading ? (
          <div className={styles.loaderWrap}>
            <Skeleton variant="table" rows={5} cols={4} />
          </div>
        ) : error ? (
          <div className="unv-empty">{t('reports.kpi_load_failed')}</div>
        ) : (
          <AccreditationGrid data={data} />
        )}
      </div>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default AccreditationReportPage
